import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Box, Breadcrumbs, Typography } from '@mui/material'
import { Circle } from '@mui/icons-material'
import Main from '@/views/layouts/main/index'

import ErrorLimit from '@/views/components/error-limit/index.component'
import BonusEngineFormModule from '@/views/bonus-engine-form/index.module'
import { ApplicationState } from '@/state/root.models'

import routes from '@/routes'
import { FormStatusType } from '@/enums/form-status.enum'
import PageTitle from '@/views/layouts/page-title/index.layout'

const BonusEngineForm = () => {
  const { t } = useTranslation()

  const { bonusFormMode, currentBonus } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const title = `${t('pages.bonusProgram')}`

  const bonusStatusTitle = () => {
    if (bonusFormMode === FormStatusType.CREATE) {
      return t('labels.create')
    }
    if (bonusFormMode === FormStatusType.DUPLICATE) {
      return `${t('labels.duplicate')} _ ${currentBonus.name}`
    }
    return currentBonus.name
  }

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.bonusEngine')}</Typography>
      <Link to={routes.bonus.INDEX}>
        <Typography>{t('pages.bonusProgram')}</Typography>
      </Link>
      <Typography>{bonusStatusTitle()}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box mb={5} display="flex">
          <PageTitle title={title} breadcrumbs={breadcrumbs} />
        </Box>
        <BonusEngineFormModule />
      </ErrorLimit>
    </Main>
  )
}

export default BonusEngineForm
